import { createHttpLink } from 'apollo-link-http'
import { from } from 'apollo-link'
import { createProvider } from '../vue-apollo'
import { onError } from 'apollo-link-error'
import store from '@/store'

const errorHandler = onError(({ networkError, graphQLErrors }) => {
  console.log({ graphQLErrors, networkError })
  store.set('app/errors', graphQLErrors)
})

const link = createHttpLink({
  uri: `https://graphql.hittegodsportalen.se/demo/query`,
})

export const apolloProvider = createProvider({
  link: from([errorHandler, link]),
  defaultHttpLink: false,
})
